import React from 'react';
import { upgradeModalHeaders, upgradeModalSubHeaders } from 'constants/upgradeSubscription';

import UpgradeModal from '../Modal/UpgradeModal/UpgradeModal';

const UpgradeSubscription = ({
  children,
  isUpgradeModalVisible,
  toggleUpgradeModal,
  type,
}) => {
  const headText = upgradeModalHeaders[type];
  const subHeadText = upgradeModalSubHeaders[type];

  return (
    <div>
      <UpgradeModal
        isVisible={isUpgradeModalVisible}
        toggleModal={toggleUpgradeModal}
        headText={headText}
        subHeadText={subHeadText}
      />
      {children}
    </div>
  );
};

export default UpgradeSubscription;



// WEBPACK FOOTER //
// ./src/components/subscriptionFeature/upgradeSubscription.js